import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Brain, Globe2, BatteryWarning } from 'lucide-react';
export function Problem() {
  return <section className="py-20 px-4" data-id="element-174">
      <div className="max-w-4xl mx-auto" data-id="element-175">
        <FadeIn data-id="element-176">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-177">
            El problema no es que seas una "mala madre" o que tus hijos sean
            "malcriados".
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-178">
          <FadeIn delay={0.1} data-id="element-179">
            <div className="bg-white p-8 rounded-3xl shadow-sm border border-cream-200 h-full" data-id="element-180">
              <div className="w-14 h-14 bg-sage-100 text-sage-700 rounded-2xl flex items-center justify-center mb-6" data-id="element-181">
                <Brain className="w-7 h-7" data-id="element-182" />
              </div>
              <h3 className="text-xl font-bold mb-4 font-heading text-terracotta" data-id="element-183">
                Modo Supervivencia
              </h3>
              <p className="text-warmBrown-700" data-id="element-184">
                El problema es que tu sistema nervioso está operando en modo de
                supervivencia. Cuando el agotamiento se junta con la falta de
                herramientas modernas, el grito se convierte en tu única arma.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-185">
            <div className="bg-white p-8 rounded-3xl shadow-sm border border-cream-200 h-full" data-id="element-186">
              <div className="w-14 h-14 bg-gold-100 text-gold-700 rounded-2xl flex items-center justify-center mb-6" data-id="element-187">
                <Globe2 className="w-7 h-7" data-id="element-188" />
              </div>
              <h3 className="text-xl font-bold mb-4 font-heading text-terracotta" data-id="element-189">
                La Carga Latina en USA
              </h3>
              <p className="text-warmBrown-700" data-id="element-190">
                En los Estados Unidos, las madres latinas cargamos con el peso
                del trabajo, la adaptación cultural y la presión de criar solas,
                muchas veces sin la red de apoyo que teníamos en nuestro país.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-191">
            <div className="bg-white p-8 rounded-3xl shadow-sm border border-cream-200 h-full" data-id="element-192">
              <div className="w-14 h-14 bg-coral-100 text-coral-700 rounded-2xl flex items-center justify-center mb-6" data-id="element-193">
                <BatteryWarning className="w-7 h-7" data-id="element-194" />
              </div>
              <h3 className="text-xl font-bold mb-4 font-heading text-terracotta" data-id="element-195">
                El Efecto del Grito
              </h3>
              <p className="text-warmBrown-700" data-id="element-196">
                Los gritos no enseñan respeto, enseñan miedo. Y lo peor: dejan
                de funcionar con el tiempo, obligándote a gritar cada vez más
                fuerte para obtener el mismo resultado.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}